import { createAction } from 'redux-actions'

export const setUpdatingBlock = createAction('UPDATING_BLOCK/SET_UPDATE_BLOCK')
